import React, { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import DialogTitleComponent from "../../../../components/dialog_title";
import { EliminarUsuarioPlataforma } from "../../../../services/request/reclutamiento/usuariosPlataforma";
import { MainContext } from "../../../../App";

export default function DialogDelete(props) {
	const {
		is_open,
		data,
		handle_close,
		mutate_usuarios,
	} = props;

	const MainCTX = useContext(MainContext);

	const handleDelete = async () => {
		try {
			await EliminarUsuarioPlataforma(data._id);
			MainCTX.ShowSnackbar("Usuario eliminado exitosamente.");
		} catch (error) {
			MainCTX.ShowSnackbar("Error al intentar eliminar el usuario.", error);
		} finally {
			mutate_usuarios();
			handle_close();
		}
	}

	return (
		<Dialog open={is_open} onClose={handle_close} maxWidth="md" PaperProps={{ style: { borderRadius: 20 } }} fullWidth>
			<DialogTitleComponent onClose={handle_close}>Eliminar Usuario</DialogTitleComponent>
			<DialogContent>
				<DialogContentText>
					{`Debe confirmar la eliminación del usuario "${data ? `${data._usuario_ref.nombre} ${data._usuario_ref.apellido_paterno} ${data._usuario_ref.apellido_materno}` : ""}".`}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handle_close} color="primary">Cancelar</Button>
				<Button onClick={handleDelete} variant="contained" color="primary">Aceptar</Button>
			</DialogActions>
		</Dialog>
	);
}